import React, { FC } from 'react';

import { StandardRuleCompliance } from '@ariksa/compliance-policies/api';
import { Box, Stack, UseDisclosureProps } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import {
  ChakraMarkdown,
  DetailsIdentifier,
  ExpandableText,
  StackedHeader,
} from 'components/DataDisplay';
import { BorderedBox } from 'components/DataDisplay/Box/BorderedBox';
import { Drawer } from 'components/Overlay';

import { selectBlueprints } from '../../../../selectors';

import { ComplianceSubControls } from './ComplianceSubControls';

interface Props {
  control: StandardRuleCompliance;
  isOpen: boolean;
  onClose: () => void;
  addPolicy?: UseDisclosureProps;
  selectedPolicies?: string[];
  setSelectedPolicies?(value: string[]);
  action?: 'Create' | 'Show' | 'Update';
}

export const BlueprintSubControlsDrawer: FC<Props> = props => {
  const {
    control,
    isOpen,
    onClose,
    addPolicy,
    selectedPolicies,
    setSelectedPolicies,
    action,
  } = props;
  const { blueprint } = useSelector(selectBlueprints);
  const compliance = control?.compliance ?? blueprint.data.compliance;

  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      header={
        <StackedHeader
          upper={compliance?.replace('_', ' ')}
          lower={'Control: ' + control?.control}
          type={compliance}
          iconFilled={false}
        />
      }
      styles={{ content: { maxW: '100rem' } }}
      closeButton
      body={
        <Stack h="full" w="full" spacing={5}>
          <DetailsIdentifier
            label="Control Description"
            isInline={false}
            value={
              <ExpandableText noOfLines={4}>
                <ChakraMarkdown content={control?.control_description || '-'} />
              </ExpandableText>
            }
          />
          <BorderedBox h="full" p={4} flex={1}>
            <Box h="full" w="full">
              <ComplianceSubControls
                control={control}
                addPolicy={addPolicy}
                selectedPolicies={selectedPolicies}
                setSelectedPolicies={setSelectedPolicies}
                action={action}
              />
            </Box>
          </BorderedBox>
        </Stack>
      }
    />
  );
};
